import { Injectable } from '@angular/core';
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportService {

  constructor(private _apiService: ApiService,
    private _commonService: CommonService) { }

  getReports(reportType, facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getReports/' + reportType + '/' + facilityId + '/' + customerId)
  }

  getReportsPaged(reportType, facilityId, customerId, pageSize, pageNumber) {
    return this._apiService
      .get('', 'api/dashboard/getReportsPaged/' + reportType + '/' + facilityId + '/' + customerId+ '/' + pageSize+ '/' + pageNumber)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts